<script>
	// Components
	import StepInputFloat from '@/Components/StepInputFloat.svelte';
	import { createEventDispatcher } from 'svelte';
	import SportSelectionStore from '@/Stores/Sport/SportSelectionStore.js';

	const dispatch = createEventDispatcher();
	export let selectionId;
	export let width = 'w-14';
	export let isEditingLines = false;
	export let onEnter = false;
	export let isManual = false;
	export let compact = false;

	let newOverrideLine;
	$: selection = $SportSelectionStore && $SportSelectionStore.where('id', selectionId).first();
	$: currentValue = selection && parseFloat(selection.line);
	$: (newOverrideLine || currentValue) && calcOverride();
	$: !isEditingLines && calcOverride();
	$: currentValue && emitUpdate();

	function calcOverride() {
		if (isManual) {
			currentValue = parseFloat(newOverrideLine);
		}
		if (!isEditingLines || (currentValue && !newOverrideLine)) {
			currentValue = parseFloat(currentValue);
			newOverrideLine = parseFloat(currentValue);
		} else if (newOverrideLine) {
			currentValue = parseFloat(newOverrideLine);
		}
	}

	function emitUpdate() {
		dispatch('update', currentValue);
	}

	function setClosest(direction) {
		newOverrideLine = direction === 'up' ? parseFloat(newOverrideLine) + 0.5 : parseFloat(newOverrideLine) - 0.5;
	}
</script>

<StepInputFloat
	bind:value={newOverrideLine}
	enabled={false}
	{compact}
	inputWidth={width}
	highlight={isManual}
	bgHighlight={currentValue != newOverrideLine}
	on:updated={() => (isEditingLines = true)}
	on:inc={() => setClosest('up')}
	on:dec={() => setClosest('down')}
	on:enter={() => onEnter && onEnter()}
/>
